"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIBanner;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIAlert = _interopRequireDefault(require("../alert/UIAlert"));

function UIBanner(_ref) {
  var className = _ref.className,
      children = _ref.children,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  return _react.default.createElement(_UIAlert.default, (0, _extends2.default)({}, other, {
    className: (0, _classnames.default)('private-alert--banner', 'private-alert--page-wide', className)
  }), children);
}

UIBanner.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIAlert.default.propTypes, ['type']));
UIBanner.defaultProps = (0, _extends2.default)({}, _UIAlert.default.defaultProps);
UIBanner.displayName = 'UIBanner';
module.exports = exports.default;